import axios from 'axios';
import { GiftCertificateUsageEntity } from '../../Models/Entities';

/**
 * Returns the gift-certificate usages for a transaction (most recent first). The previous
 * implementation used `fetchAndCount` but no caller used the count, so this is a plain fetch.
 */
export async function fetchGiftCertificateUsagesByTransactionId(transactionId: string) {
	const response = await axios.get<GiftCertificateUsageEntity[]>(
		`/api/entity/GiftCertificateUsageEntity/for-transaction/${transactionId}`,
	);
	return { data: (response.data ?? []).map(row => new GiftCertificateUsageEntity(row)) };
}
